module.exports = __webpack_public_path__ + "static/media/bell.549e7e63.svg";